import { render, staticRenderFns } from "./previewSection.vue?vue&type=template&id=7e20bb4c&scoped=true"
import script from "./previewSection.vue?vue&type=script&lang=js"
export * from "./previewSection.vue?vue&type=script&lang=js"
import style0 from "./previewSection.vue?vue&type=style&index=0&id=7e20bb4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e20bb4c",
  null
  
)

export default component.exports